/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Features_AlphaInputs */

const en_gc_resources_features_alpha = /** @type {(inputs: Gc_Resources_Features_AlphaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Still in alpha. Keep a backup and save your work before closing.`)
};

const zh_gc_resources_features_alpha = /** @type {(inputs: Gc_Resources_Features_AlphaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`产品仍处于 Alpha 阶段。请保留备份，并在关闭前保存。`)
};

/**
* | output |
* | --- |
* | "Still in alpha. Keep a backup and save your work before closing." |
*
* @param {Gc_Resources_Features_AlphaInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_features_alpha = /** @type {((inputs?: Gc_Resources_Features_AlphaInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Features_AlphaInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_features_alpha(inputs)
	return zh_gc_resources_features_alpha(inputs)
});
export { gc_resources_features_alpha as "gc.resources.features.alpha" }